import { call, put, takeEvery } from "redux-saga/effects";
import resources from "../../../config/resources";
import config from "../../../config/index";
import fetchService from "../../../lib/fetchService";
import { RECEIVED_JOB_REQUEST, receivedJobError, receivedJobSuccess } from "./action";
import { handleSagaError } from "../../../dataproviders/errorResponseHandler";

const requestSaga = function*({ payload }) {
  const { job } = payload;

  const url = `${config.urls.BACKEND}/v2/${resources.JOBS}/${encodeURIComponent(job)}/received`;

  try {
    const response = yield call(fetchService.post, url);

    for (const action of yield call(handleSagaError, response, receivedJobError)) {
      yield put(action);
      return;
    }

    if (response.ok) {
      const responseData = yield call(() => response.json());
      yield put(receivedJobSuccess(responseData));
    } else {
      const statusCode = response.status;
      yield put(receivedJobError(new Error(`Request failed with error ${statusCode}!`)));
    }
  } catch (e) {
    yield put(receivedJobError(e));
  }
};

export default function*() {
  yield takeEvery(RECEIVED_JOB_REQUEST, requestSaga);
}
